import React, { useEffect, useState } from "react";
import "../login/login.scss";
import axios from "axios";
import url from "../../url.json";
import { withTranslation } from "react-i18next";
import {
  Form,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import headers from "../../config/headers";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { tokenReducer } from "../../Redux/Reducers/Token/TokenReducer";
import { IsLegalReducer } from "../../Redux/Reducers/IsLegal/IsLegal";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Box from "@mui/material/Box";
import { ToastContainer, toast } from "react-toastify";
import { Spin, Button, Alert } from "antd";
function ForgotPass({ t }) {
  const [load, setload] = useState(false);
  const [error, setError] = useState();
  const [serverError, setServerError] = useState();
  const email = useSelector((state) => state.email);
  const navigate = useNavigate();
  useEffect(() => {
    if (email.value == "") {
      navigate("/forgotpassword");
    }
  }, []);
  const handleChange = (value) => {
    value.preventDefault();
    setload(true);
    setServerError();
    const data = {
      email: email.value,
      password: value.target.password.value,
      code: value.target.code.value,
      password_confirmation: value.target.password_confirmation.value,
    };
    axios
      .post(url.url + "/email/verified", data, { headers: headers() })
      .then((res) => {
        toast.success(res.data.data.success);
        setload(false);
        navigate("/login");
        setError();
      })
      .catch((err) => {
        setload(false);
        const res = err.response;
        // Server javob bermadi (internet / CORS / server o'chiq)
        if (!res) {
          setServerError([err.message]);
          toast.error(t("Password update failed"));
          return;
        }
        if (res.status == 401) {
          window.location = "/";
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          return;
        }
        const body = res.data;
        const errors = body?.errors || body?.data?.errors;
        // Maydon ostida ham ko'rsatish uchun (kod noto'g'ri, parollar mos emas)
        setError(errors);
        // Validatsiya xatolarining barchasi (qaysi maydon bo'lishidan qat'i nazar)
        const fieldMessages =
          errors && typeof errors === "object"
            ? Object.values(errors).flat().filter(Boolean)
            : [];
        const mainMessage =
          body?.error ||
          body?.message ||
          body?.data?.error ||
          body?.data?.message ||
          (typeof body === "string" ? body : "");
        const lines = fieldMessages.length
          ? fieldMessages
          : [mainMessage || `${res.status} ${res.statusText || ""}`.trim()];
        setServerError(lines);
        toast.error(lines[0] || t("Password update failed"));
      });
  };
  const steps = [t("Enter email"), t("Create a password")];

  return (
    <div className="wrapper">
      <div className="forms_login">
        <div className="titless">{t("Forgot password")}</div>
        <Box sx={{ width: "100%" }}>
          <Stepper activeStep={1} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel className="ll">{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
        <Form onSubmit={handleChange}>
          <span className="lab">
            {t("Code sent to email:")} {email.value}{" "}
          </span>
          <FormGroup>
            <Label className="lab" for="resetCode">
              {t("code_email")}
            </Label>
            {!error?.code ? (
              <Input
                className="inpp"
                id="resetCode"
                name="code"
                placeholder={t("code_email")}
              />
            ) : (
              <Input
                className="inpp invalid"
                id="resetCode"
                name="code"
                invalid
                placeholder={t("code_email")}
              />
            )}
            {error?.code ? (
              <i style={{ color: "red", fontSize: 14 }}>
                {[].concat(error.code).join(" ")}
                <br />
              </i>
            ) : (
              ""
            )}
            <Label className="lab" for="resetPassword">
              {t("New password")}
            </Label>

            <Input
              className={error?.password ? "inpp invalid" : "inpp"}
              invalid={!!error?.password}
              id="resetPassword"
              autoComplete="new-password"
              name="password"
              placeholder={t("New password")}
              type="password"
            />

            <Label className="lab" for="resetPasswordConfirm">
              {t("Password confirmation")}
            </Label>
            <Input
              className={
                error?.password || error?.password_confirmation
                  ? "inpp invalid"
                  : "inpp"
              }
              invalid={!!(error?.password || error?.password_confirmation)}
              id="resetPasswordConfirm"
              autoComplete="new-password"
              name="password_confirmation"
              placeholder={t("Password confirmation")}
              type="password"
            />

            {error?.password || error?.password_confirmation ? (
              <i style={{ color: "red", fontSize: 14 }}>
                {[]
                  .concat(error.password || [], error.password_confirmation || [])
                  .join(" ")}
                <br />
              </i>
            ) : (
              ""
            )}
          </FormGroup>
          {serverError ? (
            <Alert
              className="mb-3"
              type="error"
              showIcon
              closable
              onClose={() => setServerError()}
              message={t("Password update failed")}
              description={
                <div style={{ wordBreak: "break-word", fontSize: 13 }}>
                  {serverError.length > 1 ? (
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                      {serverError.map((m, i) => (
                        <li key={i}>{m}</li>
                      ))}
                    </ul>
                  ) : (
                    serverError[0]
                  )}
                </div>
              }
            />
          ) : null}
          <Button
            className="w-100"
            type="primary"
            htmlType="submit"
            loading={load}
          >
            {t("Update password")}
          </Button>
        </Form>
      </div>
    </div>
  );
}
export default withTranslation()(ForgotPass);
